import SvgIconWrapper from "./SvgIconWrapper";

export default function SubMenuSourcingIcon(
  props: React.SVGAttributes<SVGElement>
) {
  return (
    <SvgIconWrapper {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.48025 9.01325L13.3914 2.71369L12.243 2.05063L1.30394 8.36625L2.48025 9.01325Z"
          fill="currentColor"
        />
        <path
          d="M1.56775 21.1828V21.4714L1.81775 21.6158L11.3312 27.1084V27.1622L1.39143 21.4235V9.94751L1.56775 10.0499V21.1828Z"
          fill="currentColor"
          stroke="currentColor"
        />
        <path
          d="M0.218752 22.2734L11.9471 29.0448C12.0136 29.0832 12.0891 29.1034 12.1659 29.1034C12.2427 29.1034 12.3181 29.0832 12.3846 29.0448L17.1518 26.3979L16.7251 25.6401L12.625 27.9081V15.3747L23.4375 9.10855V12.8532H24.3125V8.35174C24.3144 8.27572 24.296 8.20056 24.2592 8.13398C24.2225 8.0674 24.1687 8.0118 24.1034 7.97287L12.3798 1.20149C12.3138 1.16308 12.2387 1.14285 12.1623 1.14285C12.0859 1.14285 12.0108 1.16308 11.9448 1.20149L0.217565 7.97287C0.151202 8.01133 0.0961489 8.0666 0.0579534 8.13312C0.0197579 8.19963 -0.000230632 8.27504 2.00772e-06 8.35174V21.8946C3.95863e-06 21.9714 0.0202201 22.0468 0.0586186 22.1133C0.0970172 22.1798 0.152245 22.235 0.218752 22.2734ZM0.875002 9.10855L11.75 15.3747V27.9081L0.875002 21.6419V9.10855ZM7.06163 11.6701L17.9142 5.40437L23.0187 8.3513L12.1659 14.617L7.06163 11.6701ZM12.1659 2.08555L17.0392 4.89918L6.18663 11.1649L1.31331 8.3513L12.1659 2.08555Z"
          fill="currentColor"
        />
        <g clipPath="url(#clip0_1_22343)">
          <path
            d="M23.2316 23.5865C22.3854 23.6995 21.5271 23.5003 20.8173 23.0261C20.1074 22.552 19.5947 21.8354 19.375 21.0105C19.1553 20.1856 19.2438 19.309 19.6238 18.5446C20.0038 17.7802 20.6493 17.1805 21.4396 16.8577C20.9454 16.9237 20.4709 17.0943 20.0477 17.358C19.6245 17.6218 19.2624 17.9727 18.9855 18.3873C18.7085 18.802 18.5231 19.2709 18.4416 19.7628C18.36 20.2547 18.3842 20.7584 18.5125 21.2402C18.6408 21.7221 18.8704 22.171 19.1858 22.5572C19.5012 22.9434 19.8952 23.258 20.3417 23.48C20.7882 23.702 21.2769 23.8263 21.7752 23.8447C22.2735 23.863 22.77 23.775 23.2316 23.5865Z"
            fill="currentColor"
          />
          <path
            d="M27.0086 23.9405L27.0085 23.9405C26.9456 23.8776 26.8603 23.8423 26.7714 23.8423C26.6824 23.8423 26.5971 23.8776 26.5342 23.9405C26.5342 23.9405 26.5342 23.9405 26.5342 23.9405L26.3338 24.141L25.7242 23.5314L25.6417 23.4489L25.5592 23.5314L25.2499 23.8408L25.1674 23.9233L25.2499 24.0058L25.8594 24.6153L25.6549 24.8198L25.0454 24.2102L24.9629 24.1277L24.8804 24.2102L24.571 24.5196L24.4885 24.6021L24.571 24.6846L25.1806 25.2941L24.9801 25.4946C24.9801 25.4946 24.9801 25.4946 24.9801 25.4946C24.9172 25.5575 24.8819 25.6428 24.8819 25.7318C24.8819 25.8207 24.9172 25.906 24.9801 25.9689L28.6159 29.605L28.6159 29.605C28.8849 29.874 29.2498 30.0251 29.6302 30.0251C30.0107 30.0251 30.3755 29.874 30.6445 29.605C30.9135 29.336 31.0646 28.9711 31.0646 28.5907C31.0646 28.2103 30.9135 27.8454 30.6445 27.5764L27.0086 23.9405ZM29.0903 29.1304L26.7552 26.7952L27.8349 25.7155L30.17 28.0507C30.3131 28.194 30.3934 28.3882 30.3934 28.5907C30.3934 28.7901 30.3155 28.9814 30.1766 29.124L30.1702 29.1304C30.0269 29.2734 29.8327 29.3537 29.6303 29.3537C29.4278 29.3537 29.2336 29.2734 29.0903 29.1304ZM25.6916 25.7318L26.7714 24.6521L27.3605 25.2412L26.2808 26.3209L25.6916 25.7318Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.233333"
          />
          <path
            d="M21.4323 25.5898C24.3026 25.5898 26.6294 23.263 26.6294 20.3927C26.6294 17.5224 24.3026 15.1955 21.4323 15.1955C18.562 15.1955 16.2351 17.5224 16.2351 20.3927C16.2351 23.263 18.562 25.5898 21.4323 25.5898Z"
            stroke="currentColor"
            strokeWidth="0.8"
          />
          <path
            d="M21.4323 16.9799C19.5474 16.9799 18.0194 18.5079 18.0194 20.3927C18.0194 22.2776 19.5474 23.8056 21.4323 23.8056C23.3172 23.8056 24.8451 22.2776 24.8451 20.3927C24.8451 18.94 23.9375 17.6993 22.6584 17.2067"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
          <path
            d="M19.5153 19.4063C19.3836 19.5951 19.373 19.6302 19.3836 19.7882"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
          <path
            d="M19.4265 20.941C19.5193 21.1516 19.7787 21.8429 20.6743 22.3432"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1_22343">
            <rect
              width="16"
              height="16"
              fill="currentColor"
              transform="translate(15.4375 14.3979)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIconWrapper>
  );
}
